import { useState } from "react";
import { Panel, PanelBody } from "components/Panel";
import ActionLink from "components/ActionLink";
import { ForMoreInfoZendeskLink } from "components/Help";
import { useAnalysisResults } from "containers/BudgetHome";
import StockNumbers from "./StockNumbers";
import RsuFromPastureByBlock from "./RsuFromPastureByBlock";
import Diet from "./Diet";
import DairyFarmSystemType from "./DairyNZFarmSystemType";

export default function PastureAndDiet({ analysis }) {
    const { data: analysisResults } = useAnalysisResults(analysis);
    const [enterpriseId, setEnterpriseId] = useState();

    // We use stockingRates.byEnterprise to make sure the submenu is ordered by dominant enterprise first
    const stockingRates = analysisResults?.animals?.stockingRates;
    if (!stockingRates) {
        return null;
    }

    const selectedEnterpriseId = enterpriseId || stockingRates.byEnterprise[0]?.id;

    const dairyEnterprise = analysis?.enterprises?.find(e => e.type === "Dairy");
    const isDairy = dairyEnterprise && dairyEnterprise.id === selectedEnterpriseId;

    return (
        <Panel title="Block pasture &amp; diet (ME source)" info={PAGE.INFO} skyBlue className="u-page-break">
            <PanelBody>
                <ul className="SubMenu">
                    {stockingRates.byEnterprise.map((enterprise) => (
                        <li key={enterprise.id} className={`SubMenu-item ${enterprise.id === selectedEnterpriseId ? "is-active" : ""}`}>
                            <ActionLink onClick={() => setEnterpriseId(enterprise.id)}>
                                <span>{enterprise.name}</span>
                            </ActionLink>
                        </li>
                    ))}
                </ul>
                <StockNumbers analysis={analysis} enterpriseId={selectedEnterpriseId} />
                {isDairy && <DairyFarmSystemType analysis={analysis} enterpriseId={selectedEnterpriseId} />}
                <RsuFromPastureByBlock analysis={analysis} enterpriseId={selectedEnterpriseId} />
                <Diet analysis={analysis} enterpriseId={selectedEnterpriseId} />
            </PanelBody>
        </Panel>
    )
}

const PAGE = {
    INFO: <>
        Shows the monthly stock numbers, the estimated monthly RSU from pasture for each block, and the estimated monthly breakdown of diet for each animal enterprise.
        <ForMoreInfoZendeskLink url="https://support.overseer.org.nz/hc/en-us/articles/900001981206-Animal-Report-Description-of-Block-Pasture-Diet-ME-Source-Report" />
    </>
}
